import { render, staticRenderFns } from "./InfoDocumentsGroup.vue?vue&type=template&id=8e5d303c&scoped=true&"
import script from "./InfoDocumentsGroup.vue?vue&type=script&lang=js&"
export * from "./InfoDocumentsGroup.vue?vue&type=script&lang=js&"
import style0 from "./InfoDocumentsGroup.vue?vue&type=style&index=0&id=8e5d303c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d303c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiDocumentIcon: require('/app/components/ui/DocumentIcon.vue').default,UiInfoDocumentsItem: require('/app/components/storyblok/ui/InfoDocumentsItem.vue').default})
